import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUser,
  faEnvelope,
  faLock,
  faEye,
  faEyeSlash,
  faArrowUp,
  faArrowDown,
  faExpand,
  faCompress,
  faBolt,
  faSpinner,
  faSort,
  faSortUp,
  faSortDown,
  faMoon,
  faChevronRight,
  faGlobe,
  faCaretRight,
  faUpIcon,
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faUser,
  faEnvelope,
  faLock,
  faEye,
  faEyeSlash,
  faArrowUp,
  faArrowDown,
  faExpand,
  faCompress,
  faBolt,
  faSpinner,
  faSort,
  faSortUp,
  faSortDown,
  faMoon,
  faChevronRight,
  faGlobe,
  faCaretRight
);
